import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  value: null,
  federal_hash_tax_id: null,
  federalTaxId: null,
  customer_email: null,
};

export const custNOSlice = createSlice({
  name: 'customerNO',
  initialState,
  reducers: {
    setSelectedCustomerNO: (state, action) => {
      state.value = action.payload;
    },
    setHashTaxIdCustomer: (state, action) => {
      state.federal_hash_tax_id = action.payload;
    },
    setFederalTaxId: (state, action) => {
      state.federalTaxId = action.payload;
    },
    setSelectCustomerEmail: (state, action) => {
      state.customer_email = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setSelectedCustomerNO, setHashTaxIdCustomer, setFederalTaxId, setSelectCustomerEmail } =
  custNOSlice.actions;

export default custNOSlice.reducer;
